import { render, staticRenderFns } from "./VistaReportes.vue?vue&type=template&id=3d68a2a4&"
import script from "./VistaReportes.vue?vue&type=script&lang=ts&"
export * from "./VistaReportes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports